module.exports = __webpack_public_path__ + "static/media/Sofia-Pro-Extra-Light.8a323e36.ttf";